import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const RECEIVABLES_RISK_FILTERS = REPORTS_DEFAULT_FILTERS

export const RECEIVABLES_RISK_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'currency' | 'percent' | 'days'
}> = [
  {
    id: 'total-ar',
    title: 'Total Accounts Receivable',
    footer: 'Sum of outstanding balance',
    format: 'currency',
  },
  {
    id: 'insurance-ar',
    title: 'Insurance AR',
    footer: 'Sum of insurance balance',
    format: 'currency',
  },
  {
    id: 'patient-ar',
    title: 'Patient AR',
    footer: 'Sum of patient balance',
    format: 'currency',
  },
  {
    id: 'ar-over-90',
    title: 'AR > 90 Days',
    footer: 'Percentage of AR > 90 Days',
    format: 'percent',
  },
  {
    id: 'avg-days-in-ar',
    title: 'Average Days in AR',
    footer: 'Average number of days for payment',
    format: 'days',
  },
]

export const INSURANCE_AR_PIE_COLOR = 'var(--blue-400)'
export const PATIENT_AR_PIE_COLOR = 'var(--orange-300)'

export type HighBalancePatientRow = {
  id: string
  patient: string
  balance: string
  daysOutstanding: string
}
